// import React from 'react';
// import { Chart } from 'react-chartjs-2';
// // import { Container } from 'mdbreact';
// // import createHistory from 'history/createBrowserHistory';


// // chart custom component
// class DoughnutChart extends React.Component {
//     componentDidMount() {
//         //doughnut
//         var ctxD = document.getElementById("doughnutChart").getContext('2d');
//         new Chart(ctxD, {
//             type: 'doughnut',
//             data: {                
//                 datasets: [
//                     {
//                         data: [300, 50],
//                         backgroundColor: ["#F7464A", "#46BFBD",],
//                         hoverBackgroundColor: ["#FF5A5E", "#5AD3D1"]
//                     }
//                 ]
//             },
//             options: {
//                 responsive: true
//             }
//         });
//     }
//     render() {
//         return (
//         <div>
//           <canvas id="doughnutChart" ></canvas>
//         </div>
//         );
//     }

// };

// export default DoughnutChart;


import React from 'react';
import {
  Chart,
  DoughnutController,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
} from 'chart.js';

// Register required components with Chart.js
Chart.register(DoughnutController, ArcElement, Tooltip, Legend, CategoryScale);

class DoughnutChart extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    const ctx = this.canvasRef.current.getContext('2d');
    this.chartInstance = new Chart(ctx, {
    //   type: 'doughnut',
      data: {
        // labels: ['Red', 'Green'],
        // datasets: [
        //   {
        //     data: [300, 50],
        //     backgroundColor: ['#F7464A', '#46BFBD'],
        //     hoverBackgroundColor: ['#FF5A5E', '#5AD3D1'],
        //   },
        // ],
      },
    //   options: {
    //     responsive: true,
    //     maintainAspectRatio: false,
    //   },
    });
  }

  componentWillUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  }

  render() {
    return (
      <div style={{ width: '300px', height: '300px' }}>
        <canvas ref={this.canvasRef}></canvas>
      </div>
    );
  }
}

export default DoughnutChart;
